import { Link } from "react-router-dom";

export default function SiteFootnote({ className = "" }) {
  return (
    <p
      data-testid="site-footnote"
      className={`text-[11px] text-[#5C665D] leading-relaxed text-center py-6 px-6 ${className}`}
    >
      © {new Date().getFullYear()} CFO Grade. Educational insights for business owners — not financial advice.{" "}
      <Link
        to="/valuation"
        className="underline underline-offset-2 hover:text-[#1F382E] transition-colors"
        data-testid="site-footnote-valuation-link"
      >
        Valuation calculator
      </Link>
      {" · "}
      <Link
        to="/benchmarks"
        className="underline underline-offset-2 hover:text-[#1F382E] transition-colors"
        data-testid="site-footnote-benchmarks-link"
      >
        Industry benchmarks
      </Link>
      {" · "}
      <Link
        to="/disclaimer"
        className="underline underline-offset-2 hover:text-[#1F382E] transition-colors"
        data-testid="site-footnote-disclaimer-link"
      >
        Full terms
      </Link>
      {" · "}
      <Link
        to="/admin"
        className="underline underline-offset-2 hover:text-[#1F382E] transition-colors opacity-50 hover:opacity-100"
        data-testid="site-footnote-admin-link"
        aria-label="Operator admin"
      >
        Admin
      </Link>
      .
    </p>
  );
}
